import React, {useEffect, useState} from 'react';
import styles from './UploadFieldSettings.module.scss';
import {Checkbox, Radio, Select} from "uikit";
import {useSelector} from "react-redux";
import TriangleIcon from "@/assets/images/icons/16/chevron-down.svg";


const UploadFieldSettings = ({fieldData, current, onCurrentChange, handleChange}) => {
    const selector = useSelector(state => state);
    const {maxSizes, mimeTypes} = selector['admin'].constants;

    const [radioChecked, setRadioChecked] = useState(0);
    const [expandedCategories, setExpandedCategories] = useState({});
    const [selectedItems, setSelectedItems] = useState({});

    useEffect(() => {
        onCurrentChange(prev => ({
            ...prev,
            settings: {...prev.settings, max_size: fieldData.settings?.max_size || 10485760}
        }));
        initCategory()
        setRadioChecked(fieldData.settings.mimes.length > 0 ? 1 : 0);
    }, [fieldData.settings, mimeTypes, onCurrentChange]);

    const initCategory = () => {
        const initialSelectedItems = {};
        Object.entries(mimeTypes).forEach(([category, types]) => {
            initialSelectedItems[category] = {};
            Object.keys(types).forEach(mimeType => {
                initialSelectedItems[category][mimeType] = fieldData.settings.mimes.includes(mimeType);
            });
        });
        setSelectedItems(initialSelectedItems);
    }

    const toggleCategory = (category: string) => {
        setExpandedCategories(prev => ({
            ...prev,
            [category]: !prev[category]
        }));
    };

    const handleMimeTypeChange = (category: string, mimeType: string, isChecked: boolean) => {
        setSelectedItems(prev => ({
            ...prev,
            [category]: {
                ...prev[category],
                [mimeType]: isChecked
            }
        }));
        onCurrentChange(prev => ({
            ...prev,
            settings: {
                ...prev.settings,
                mimes: isChecked ? [...prev.settings.mimes, mimeType] : prev.settings.mimes.filter(m => m !== mimeType)
            }})
        )
    };

    const handleCategoryChange = (category: string, isChecked: boolean) => {
        const types = Object.keys(mimeTypes[category]);
        const updatedCategory = types.reduce((acc, mimeType) => {
            acc[mimeType] = isChecked;
            return acc;
        }, {});
        setSelectedItems(prev => ({...prev, [category]: updatedCategory}));
        onCurrentChange(prev => ({
            ...prev,
            settings: {
                ...prev.settings,
                mimes: isChecked ? Array.from(new Set([...(prev.settings?.mimes ?? []), ...types])) : (prev.settings?.mimes ?? []).filter((mime: string) => !types.includes(mime))
            }
        }));
    };

    const handleMaxSizeChange = (value: number) => {
        onCurrentChange(prev => ({
            ...prev,
            settings: {...prev.settings, max_size: value}
        }));
    };

    return (
        <>
            <div className={'ui-cp__tickets-actions'}>
                <div className="ui-cp__ticket-editor_count">
                    <Select
                        data={maxSizes}
                        value={current.settings.max_size}
                        onChange={handleMaxSizeChange}
                        label={'Размер файла'}
                    />
                </div>

                <div className={styles.type}>
                    <p>Типы файлов</p>
                    <div className={styles.btns}>
                        <Radio
                            size="small"
                            checked={radioChecked === 0}
                            onChange={() => {
                                setRadioChecked(0);
                                onCurrentChange(prev => ({
                                    ...prev,
                                    settings: {
                                        ...prev.settings,
                                        mimes: []
                                    }
                                }));
                            }}
                        >
                            Все доступные
                        </Radio>
                        <Radio
                            size="small"
                            checked={radioChecked === 1}
                            onChange={() => setRadioChecked(1)}
                        >
                            Настроить вручную
                        </Radio>
                    </div>
                </div>
            </div>

            {radioChecked === 1 && (
                <div className={'ui-cp__tickets-actions'}>
                    <div className={styles.category}>
                        {Object.entries(mimeTypes).map(([category, types]) => {
                            const allChecked = Object.values(selectedItems[category] || {}).every(Boolean);
                            return (
                                <div key={category} className={styles.categoryItem}>
                                    <div className={styles.categoryHeader}>
                                        <Checkbox
                                            value={allChecked}
                                            onChange={(isChecked: boolean) => handleCategoryChange(category, isChecked)}
                                            size="medium"
                                        >
                                            <span>{category}</span>
                                        </Checkbox>
                                        <div
                                            className={`${styles.icon} ${expandedCategories[category] ? styles.opened : ''}`}
                                            onClick={() => toggleCategory(category)}
                                        >
                                            <TriangleIcon/>
                                        </div>
                                    </div>
                                    {expandedCategories[category] && (
                                        <ul>
                                            {Object.entries(types).map(([mimeType, label]) => (
                                                <li key={mimeType}>
                                                    <Checkbox
                                                        value={!!selectedItems[category]?.[mimeType]}
                                                        onChange={(isChecked: boolean) => handleMimeTypeChange(category, mimeType, isChecked)}
                                                        size="small"
                                                    >
                                                        {label}
                                                    </Checkbox>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}
        </>
    );
};

export default UploadFieldSettings;
